import { styled } from '@mui/material';

import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

export const StyledMockupWrapper = styled('div')({
  ...mainPreviewContainerStyles,
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
});

export const StyledContentWrapper = styled('div')({
  flexDirection: 'column',
  padding: '60px 12px',
  width: '100%',
  color: COLORS.black,
  display: 'flex',
  boxSizing: 'border-box',
});

export const StyledFakeInputLabel = styled('div')({
  fontSize: '12px',
  fontWeight: 600,
  marginBottom: 8,
});

export const StyledFakeInput = styled('div')({
  backgroundColor: COLORS.gray005,
  borderRadius: '6px',
  padding: '5px 10px',
  height: 36,
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  marginBottom: 16,
});

export const StyledLine = styled('div')({
  borderTop: `2px solid ${COLORS.gray02}`,
  marginInline: '-12px',
});

export const StyledTextEllipsis = styled('div')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const StyledMessage = styled('div')({
  color: COLORS.gray06,
  paddingBlock: 10,
  fontSize: '13px',
  wordBreak: 'break-word',
});
